import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type State = {
  layoutType: 'grid' | 'list'
}

export type Action = {
  actions?: {
    setLayoutType: (layoutType: 'grid' | 'list') => void
  }
}

export const useLayoutsStore = create(
  persist<State & Action>(
    (set) => ({
      layoutType: 'grid',
      actions: {
        setLayoutType: (layoutType) => {
          set({
            layoutType,
          })
        },
      },
    }),
    {
      name: 'layouts-store',
      partialize: (state) => ({
        layoutType: state.layoutType,
      }),
    },
  ),
)
